import { Grid, Stack } from "@mui/material";
import { Component } from "react";
import { Button } from "../../components/Button";
import { Paper } from "../../components/Paper";
import { withLocale, WithLocaleProps } from "../../providers/LocaleProvider";
import Drawing from "../../resources/images/drawing-inactive.svg";
import SwitchToCompanyIcon from "../../resources/images/icons-office.svg";

class UnavailableViewBase extends Component<any & WithLocaleProps, any> {
  static defaultProps = {
    headingKey: "inactive.appUnavailable",
    messageKey: "inactive.tryAgainSoon",
    actions: ["tryAgain"]
  };

  constructor(props: any) {
    super(props);
  }

  onSwitchToOrganizationClick(e: any) {
    const { onSwitchToOrganization } = this.props;
    if (onSwitchToOrganization) onSwitchToOrganization(e, false);
  }

  onTryAgainClick(e: any) {
    window.location.reload();
  }

  render() {
    const { headingKey, messageKey, actions, translate } = this.props;

    return (
      <Paper className='klayo-unavailableview' padding='44px 64px 48px 64px'>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <h1>{translate(headingKey)}</h1>
            <div className='klayo-unavailableview_message'>{translate(messageKey)}</div>
            <Stack direction='row' className='klayo-unavailableview_actions' spacing={2}>
              {actions && actions.includes("switchOrg") && (
                <Button
                  label={translate("inactive.switchToYourCompany")}
                  startIcon={<SwitchToCompanyIcon />}
                  onClick={this.onSwitchToOrganizationClick.bind(this)}
                />
              )}

              {actions && actions.includes("tryAgain") && (
                <Button
                  label={translate("inactive.tryAgain")}
                  onClick={this.onTryAgainClick.bind(this)}
                />
              )}
            </Stack>
          </Grid>
          <Grid item xs={6} className='klayo-unavailableview_drawing'>
            <Drawing />
          </Grid>
        </Grid>
      </Paper>
    );
  }
}

export const UnavailableView = withLocale(UnavailableViewBase);
